export default __webpack_public_path__ + "static/media/howtouse_img_03.a66db47f.svg";